module.exports = __webpack_public_path__ + "img/bacon.e650f86b.svg";